module.exports = __webpack_public_path__ + "b9704e936e210a41523dfb0bcb70e4a7.svg";